import { useEffect } from 'react';

export default function usePreventNumberInputScroll() {
  useEffect(() => {
    const handleWheel = () => {
      if (
        document.activeElement &&
        (document.activeElement as HTMLInputElement).type === 'number'
      ) {
        (document.activeElement as HTMLInputElement).blur();
      }
    };

    // Add event listener to document
    document.addEventListener('wheel', handleWheel, { passive: false });

    // Cleanup
    return () => {
      document.removeEventListener('wheel', handleWheel);
    };
  }, []);
}
